import { useRef } from 'react';

import { useCreateInspection } from '../api/createInspection';
import { useInspectionStore } from '../store/inspection.store';

export function useInspectionTicketView() {
  const { mutateAsync: createInspectionTicket } = useCreateInspection({});
  const ticketIdRef = useRef<string | null>(null);

  const setTicket = useInspectionStore((state) => state.setTicket);
  const setInspectionTicket = useInspectionStore(
    (state) => state.setInspectionTicket
  );

  const reset = useInspectionStore((state) => state.reset);

  const startInspection = async ({
    currentTicketId,
    lpUi,
    inspectionInProgress,
    shipmentId,
    currentTicketStartDate,
  }: {
    currentTicketId: string;
    lpUi: string;
    inspectionInProgress: boolean;
    shipmentId: string;
    currentTicketStartDate?: string;
  }) => {
    try {
      if (currentTicketId && inspectionInProgress) {
        setTicket(currentTicketId);
        ticketIdRef.current = currentTicketId;
        setInspectionTicket({
          ticketId: currentTicketId,
          currentDate: currentTicketStartDate || new Date().toISOString(),
        });
      } else if (lpUi) {
        const response: any = await createInspectionTicket({
          shipmentId: shipmentId,
        });

        if (response) {
          setInspectionTicket(response);
          setTicket(response.ticketId);
          ticketIdRef.current = response.ticketId;
        } else {
          console.warn('Invalid response or missing ticket ID:', response);
        }
      }
    } catch (error) {
      console.warn('Error creating inspection ticket:', error);
    }
  };

  //clear all inspection ticket data
  const clearInspectionTicket = () => {
    ticketIdRef.current = null;
    reset();
  };

  return {
    ticketIdRef,
    setInspectionTicket,
    startInspection,
    clearInspectionTicket,
  };
}
